import { render, staticRenderFns } from "./quality_work_list.vue?vue&type=template&id=33a04d4c&scoped=true"
import script from "./quality_work_list.vue?vue&type=script&lang=js"
export * from "./quality_work_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a04d4c",
  null
  
)

export default component.exports